import "core-js/modules/es.object.to-string.js";
export default {
  i18n: require('../i18n-basucSettings'),
  props: {
    // labelCol: {
    //     type: Object,
    //     default: {span: 4}
    // },
    rules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    modalVisible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    formList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    FormWidth: {
      type: String,
      default: '500px'
    },
    dialogStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    errorTip: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    copy: function copy() {
      var _this = this;
      var input = document.getElementById("copyInput");
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        navigator.clipboard.writeText(input.value).then(function () {
          _this.$message.success(_this.$t('public.copySuccessfully'));
        });
      } else {
        console.log('no');
        var textArea = document.createElement("textarea");
        textArea.value = input.value;
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = "absolute";
        textArea.style.opacity = 0;
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise(function (res, rej) {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? res() : rej();
          textArea.remove();
          _this.$message.success(_this.$t('public.copySuccessfully'));
        });
      }
    }
  }
};